export enum NewRelicActionName {
    INTERACTION_BUTTON_CLICKED = "interactionButtonClicked",
    INTERACTION_SAVING_FORM_SUCCEEDED = "interactionSavingFormSucceeded",
    INTERACTION_SAVING_FORM_FAILED = "interactionSavingFormFailed",
}

export enum NewRelicCustomAttributeName {
    ORGANIZATION_ID = "organizationId",
    IS_COPIED_FORM = "isCopiedForm",
    FORM_TYPE = "formType",
}
